/** Forhåndsdefinerte farger for tidsslotter (mørkt tema). */
export const PERIOD_COLOR_PALETTE = [
  '#5b8def',
  '#6b9e78',
  '#c9a227',
  '#b87da8',
  '#d17b6f',
  '#4aabb8',
  '#8b7fd4',
  '#9e8b6b',
] as const;

export type PeriodPaletteColor = (typeof PERIOD_COLOR_PALETTE)[number];

export const DEFAULT_PERIOD_COLOR: PeriodPaletteColor = PERIOD_COLOR_PALETTE[0];
